const EVENTO_LOGIN = "LOGIN_GENERAL";
const EVENTO_LOGIN_ADMIN = "LOGIN_ADMIN";
const ID_CARGO_MENSUALIDAD = 1;
const ID_TIPO_USUARIO_MAESTRA = 1;

const CONSTANTES = {
    EVENTO_LOGIN: EVENTO_LOGIN,
    EVENTO_LOGIN_ADMIN: EVENTO_LOGIN_ADMIN,
    ID_CARGO_MENSUALIDAD: ID_CARGO_MENSUALIDAD,
    ID_CARGO_INCRIPCION: 2,
    ID_TIPO_USUARIO_MAESTRA: ID_TIPO_USUARIO_MAESTRA,
    ID_TIPO_COBRANZA_MENSUAL: 1,
    ID_TIPO_COBRANZA_HORAS: 2,
};

export default CONSTANTES;


// WEBPACK FOOTER //
// ./src/helpers/Constantes.js